import React, { useState, useEffect } from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { Link, useLocation } from "react-router-dom";
import { InstallationCalendarDayView } from './helpers/InstallationCalendarDayView';
import { InstallationCalendarMonthView } from './helpers/InstallationCalendarMonthView';
import { InstallerList } from './helpers/InstallerList';
import InstallationJob  from './Job';
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions/InstallationActions";

export default function InstallationAssignJob() {

    const dispatch = useDispatch()
    const {state: job} = useLocation();
    const [currentView, setView] = useState('calendarMonthView');
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedInstallerId, setSelectedInstallerId] = useState(null);
    const [selectedInstallerName, setSelectedInstallerName] = useState(null);
    const [selectedVehicleId, setSelectedVehicleId] = useState(null);
    const [selectedJob, setSelectedJob] = useState(null);
    const eventList = useSelector((state) => state.installerListVehicleEvents);

    useEffect(() => {
        if (selectedInstallerId && selectedVehicleId) {
            setView('calendarDayView');
            dispatch(actions.InstallerListVehicleEventsSingle(selectedInstallerId, eventList));
        }

    }, [dispatch, selectedInstallerId, selectedVehicleId]);

    useEffect(() => {

        window.scrollTo(0, 0);

    }, [currentView]);

    const handleDateClick = (dateStr) => {
        setSelectedDate(dateStr);
        setView('installerListView');
    };

    const onInstallerSelection = (installerId, vehicleId, selectedDate, installerName, job) => {
       

        if (selectedInstallerId == installerId && selectedVehicleId == vehicleId) {
            setView('calendarDayView');
            dispatch(actions.InstallerListVehicleEventsSingle(selectedInstallerId));
        }

        setSelectedInstallerId(installerId);
        setSelectedVehicleId(vehicleId);
        setSelectedDate(selectedDate);
        setSelectedInstallerName(installerName);
        setSelectedJob(job);


    };

    return (
        <div>
            <AuthenticatedTemplate>
                <div className="title-container">
                    <h1>Job Assignment for: {job.name}</h1>
                </div>
                <div className="page-container">

                    { {
                        'calendarMonthView': <InstallationCalendarMonthView onDateClick={handleDateClick} setView={setView} />, 
                        'installerListView': <InstallerList setView={setView} selectedDate={selectedDate} job={job} onInstallerSelection={onInstallerSelection} />, 
                        'calendarDayView': <InstallationCalendarDayView showDayView={true} onDateClick={handleDateClick} setView={setView} date={selectedDate}
                            installer={selectedInstallerName} installerId={selectedInstallerId} vehicle={selectedVehicleId} job={selectedJob} />   
                    }[currentView] }
                
                {currentView !== 'calendarDayView' && currentView !== 'installerListView' && job && 
                        <InstallationJob job={job} />
                    }
                </div>
                

            </AuthenticatedTemplate>
            <UnauthenticatedTemplate>
                <p>You are trying to assign a job while signed out. Please sign in to continue.</p>
            </UnauthenticatedTemplate>
        </div>
    );
}
